import React from 'react';
import { Box, Typography } from '@trp-individual-investor-adv-svc/ii-prosp-components';
import GenericPanel from './GenericPanel';
import { KeypointsContent } from './ConsentContent';
import { PsBeaconControl, PsBeaconControlGroup, PsBeaconError } from '../shared/BeaconRegister';

const KeyPointsPanel = ({
    panelNum,
    headerText = 'Key Points to Understand',
    checkError,
    open,
    handleChange,
}) => {
    return (
        <GenericPanel
            headerText={
                <>
                    <span>
                        {panelNum}. {headerText}
                    </span>
                    {checkError?.checkedKeyPoints && (
                        <Box>
                            <PsBeaconError id="key-points-field-error">
                                Please fill in all required fields to continue.
                            </PsBeaconError>
                        </Box>
                    )}
                </>
            }
            id="key-points-container"
            open={open}>
            <Typography
                id={KeypointsContent.headerId}
                type="body" scale={100} bold
                sx={{ paddingBottom: '40px' }}
                dangerouslySetInnerHTML={{ __html: KeypointsContent.header }}
            />
            <Typography
                id="key-points-alert"
                type="body" scale={100} light
                sx={{ paddingBottom: '40px' }}
                dangerouslySetInnerHTML={{ __html: KeypointsContent.listHeader }}
            />
            <Typography
                id="key-points-text"
                type="body" scale={100} light
            />
            {KeypointsContent.consent.map((o) => (
                <Box key={o.keyPoint} sx={{ display: 'flex', marginLeft: '15px' }} id={o.id}>
                    <Box sx={{ paddingRight: '8px' }}>
                        <span style={{ whiteSpace: 'nowrap' }}>{o.keyPoint}.</span>
                    </Box>
                    <Box>
                        <span
                            dangerouslySetInnerHTML={{
                                __html: o.consentText,
                            }}
                        />
                    </Box>
                    <br />
                </Box>
            ))}
            <Typography
                id="key-points-terms-text"
                type="body" scale={100} light
                sx={{ paddingTop: '40px', paddingBottom: '40px' }}>
                The full terms and conditions are provided in the Client Agreement and Planning
                Supplement.
            </Typography>
            <Box id="key-points-checkbox-container">
                <PsBeaconControlGroup>
                    <PsBeaconControl
                        id="checkedKeyPoints-control"
                        inline
                        style={{ paddingBottom: '24px', paddingTop: '40px' }}>
                        <input
                            required
                            type="checkbox"
                            name="checkedKeyPoints"
                            id="checkedKeyPoints"
                            onChange={handleChange && handleChange('checkedKeyPoints')}
                        />
                        <label slot="label" id="checkedKeyPoints-label" htmlFor="checkedKeyPoints">
                            {KeypointsContent.checbkoxLabel}
                        </label>
                        <div slot="error">This field is required.</div>
                    </PsBeaconControl>
                </PsBeaconControlGroup>
            </Box>
        </GenericPanel>
    );
};

export default KeyPointsPanel;
